import { AxiosError } from 'axios';
import {
  CONNECTION_ERROR_MESSAGE,
  CONNECTION_ERROR_CODES,
  HTTP_ERROR_MESSAGES,
  UNKNOWN_ERROR,
} from './getErrorMessage.constants';
import { HttpStatuses } from './getErrorMessage.types';

type Error = { error: string; reason: string };

export const extractAxiosErrorMessage = (error: AxiosError<Error>): string => {
  if (error.response?.data?.reason) {
    const { reason } = error.response.data;
    if (reason.includes('invalid mesh identifier')) {
      return 'MeSH identifier not found. Please verify the ID exists.';
    }
    return reason;
  }

  if (!error.response && error.code && CONNECTION_ERROR_CODES.includes(error.code)) {
    return CONNECTION_ERROR_MESSAGE;
  }

  const status = error.response?.status as HttpStatuses;
  return HTTP_ERROR_MESSAGES[status] || UNKNOWN_ERROR;
};
